import { useToastSettings } from '@/hooks/useToastSettings';

export function ToastSettingsManager(): null {
    // This hook handles fetching and subscribing to toast settings
    // and updating the lib/toast.ts internal state.
    useToastSettings();

    return null; // This component doesn't render anything
}
